import React from "react";
import { Card, Collapse } from "antd";
import { FIELD_TYPES } from "../../../domain/clinicalForms";
import FieldList from "./FieldList";

const GroupBlock = ({ group, values, sectionTitle }) => {
  const panelFields = group.fields.filter(
    (f) => f.type !== FIELD_TYPES.SECTION_HEADER
  );
  if (panelFields.length === 0) return null;

  const body = <FieldList fields={panelFields} values={values} />;
  const hasOwnTitle = !!group.title && group.title !== sectionTitle;

  if (!hasOwnTitle) {
    return (
      <Card size="small" style={{ marginBottom: 12 }}>
        {body}
      </Card>
    );
  }

  return (
    <Collapse
      defaultActiveKey={[group.id]}
      className="summary-collapse"
      style={{ marginBottom: 12 }}
      items={[
        {
          key: group.id,
          label: group.title,
          children: body,
        },
      ]}
    />
  );
};

export default GroupBlock;
